import React from "react";
import { useAppSelector } from "../../../../store/hooks";

export const BreakawayHullsBanner: React.FC = () => {
  const isBreakaway = useAppSelector((state) => state.shipBuilder.hull?.additionalType?.type === "breakaway");
  const breakawayHull = useAppSelector((state) => state.breakawayHull);
  
  // Check if ship has breakaway hulls
  const hasBreakawayHulls = isBreakaway || breakawayHull?.isBreakaway;

  if (!hasBreakawayHulls) return null;

  // Get breakaway sections info for display
  const getBreakawayInfo = () => {
    if (!hasBreakawayHulls) return null;
    
    const sections = breakawayHull?.sections || [];
    const totalSections = sections.length;
    
    if (sections.length > 0) {
      const sectionSizes = sections.map(s => `${s.name} (${s.size} tons)`).join(', ');
      return { totalSections, sectionSizes };
    }
    
    return { totalSections: 0, sectionSizes: 'No sections configured' };
  };

  const breakawayInfo = getBreakawayInfo();

  return (
    <div className="mb-6 p-4 border-2 border-blue-300 dark:border-blue-600 rounded-lg bg-blue-50 dark:bg-blue-900/30">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 className="text-lg font-semibold text-blue-800 dark:text-blue-200">
            Breakaway Hulls Detected
          </h3>
          {breakawayInfo && (
            <p className="text-sm text-blue-700 dark:text-blue-300 mt-1">
              {breakawayInfo.totalSections} sections: {breakawayInfo.sectionSizes}
            </p>
          )}
        </div>
      </div>
      <div className="text-sm text-blue-700 dark:text-blue-300 space-y-1">
        <p><strong>Important:</strong> Each breakaway section has its own hardpoints and firmpoints.</p>
        <p>• Configure weapons for specific sections using the form below</p>
        <p>• Hardpoints are calculated per section: 1 per 100 tons</p>
        <p>• Firmpoints for small ships: 1 (1-34 tons), 2 (35-69 tons), 3 (70-99 tons)</p>
        <p>• All standard Traveller weapon rules apply</p>
      </div>
    </div>
  );
};
